module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/left-giftset@2x_ef4acb.png";